var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _circle, _circle2, _ellipse, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9889 13.875H67.5339L62.9115 53.6281L17.6114 52.7037L12.9889 13.875Z",
    fill: "#4ABBEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6564 13.875H67.4666L62.8442 53.6281L40.6564 52.7037V13.875Z",
    fill: "#009BE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.51172H11.0939L17.5653 51.7363",
    stroke: "#39689E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7604 51.7637H18.5358C15.4723 51.7637 12.9889 54.2471 12.9889 57.3106V57.3106C12.9889 60.3741 15.4723 62.8576 18.5358 62.8576H63.8522",
    stroke: "#3F6088",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6564 51.7637H64.6932M40.6564 62.8576H64.2066",
    stroke: "#224370",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.7497,
    y: 38.8691,
    width: 5.54695,
    height: 5.54695,
    fill: "#39689E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8691,
    y: 38.8691,
    width: 5.54695,
    height: 5.54695,
    fill: "#39689E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9051,
    y: 38.8691,
    width: 5.54695,
    height: 5.54695,
    fill: "#39689E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.6332,
    cy: 67.5053,
    r: 4.62246,
    fill: "#4ABBEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.0026,
    cy: 67.5053,
    r: 4.62246,
    fill: "#009BE5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.0571,
    cy: 12.9429,
    rx: 12.9429,
    ry: 12.9429,
    fill: "#83E470"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9569 12.9429C73.9569 20.091 68.1621 25.8858 61.014 25.8858C61.014 25.8858 61.0139 20.091 61.0139 12.9429C61.0139 5.79473 61.014 0 61.014 0C68.1621 0 73.9569 5.79473 73.9569 12.9429Z",
    fill: "#01B763"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4995 14.1806L58.2393 16.2357C58.4142 16.3668 58.6329 16.4253 58.8499 16.3989C59.0669 16.3726 59.2653 16.2634 59.4037 16.0942L65.6689 9.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.006e909a8d3b5a7e18c8a562485b1b0b.svg";
export { ForwardRef as ReactComponent };